<template>

  <div>
    <!--活动列表-->
    <Activity v-if="activeName == 'activity'"></Activity>
    <!--活动核销-->
    <Clerk v-if="activeName == 'clerk'"></Clerk>

    <!--报名记录-->
    <Apply v-if="activeName == 'apply'"></Apply>
    <!--活动设置-->
    <Setting v-if="activeName == 'setting'"></Setting>
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Activity from './activity/index';
import Clerk from './clerk/index';
import Setting from './setting/getSetting.vue';
import Apply from './activity/apply';

export default {
  components: {
    Activity,
    Setting,
    Clerk,
    Apply
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'activity',
      /*切换数组*/
      sourceList: [
        {
          key: 'activity',
          value: '活动列表',
          path:'/plus/activity/activity/index'
        },
        {
          key: 'apply',
          value: '报名记录',
          path:'/plus/activity/activity/apply'
        },
        {
          key: 'clerk',
          value: '核销人员',
          path:'/plus/activity/clerk/index'
        },
        {
          key: 'setting',
          value: '活动设置',
          path:'/plus/activity/setting/getSetting'
        },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'activity',list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'activity'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/activity/index.vue